import { Icon } from "@/react/components/shared/Icon";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface PlanFeatureProps {
  color?: string;
  feature: string;
  highlightColor?: string;
  isHighlighted: boolean;
  isOnOffer: boolean;
  LabelComponent?: React.ElementType;
}

export const PlanFeature = ({
  feature,
  isHighlighted,
  isOnOffer = false,
  color = "text-slate-700 dark:text-slate-300",
  highlightColor = "text-blue-highlight",
  LabelComponent = Typography.BodySm,
}: PlanFeatureProps) => (
  <div key={feature} className="flex flex-row items-center gap-1">
    {isHighlighted ? (
      <Icon
        type="16-star-fill"
        size={16}
        className={classNames(
          "mr-1",
          isHighlighted ? highlightColor : "",
          isOnOffer ? "text-[#493B73]" : "",
        )}
        useWithFillCurrentColor
        useWithStrokeCurrentColor
      />
    ) : (
      <Icon
        type="check"
        size={16}
        useWithFillCurrentColor
        useWithStrokeCurrentColor
        className="text-green-success mr-1"
      />
    )}
    <LabelComponent color={color} key={feature}>
      {feature}
    </LabelComponent>
  </div>
);
